import { POPULAR_MG_ICONS } from './mg-icons';
import { POPULAR_SFX_ICONS } from './sfx-icons';

const POPULAR_ICONS = [...POPULAR_MG_ICONS, ...POPULAR_SFX_ICONS];

/**
 * Gets the appropriate icon component for a category name
 * @param name - The category name to find an icon for
 * @returns Icon component or undefined if not found
 */
export const getPopularIcon = ({ name }: { name: string }) =>
  POPULAR_ICONS.find((icon) => icon.name === name)?.icon;
